import { Empty, Flex, Image } from "antd";
import { useTranslation } from "react-i18next";
import { css } from "@linaria/core";
import { ImageFile } from "../../components/ImageFile.tsx";
import { useIngredient } from "./IngredientContext.tsx";

const list = css`
  width: 100%;

  .ant-image,
  .ant-image img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const IngredientPhotoList = () => {
  const { t } = useTranslation();
  const { ingredient } = useIngredient();

  if (ingredient.photos.length === 0) {
    return <Empty description={t("ingredients.photos.empty")} />;
  }

  return (
    <Flex className={list} gap="small" vertical>
      <Image.PreviewGroup>
        {ingredient.photos.map((photo) => (
          <ImageFile file={photo} key={photo.id} size="full" />
        ))}
      </Image.PreviewGroup>
    </Flex>
  );
};
